import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { useBranchOfficeDeleteDialog } from '../../../hooks/useDialog'
import { CompanyActions } from '../../../store/company'
import Dialog from '../../atoms/feedback/Dialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import Label from '../../atoms/display/Label'

export default function BranchOfficeDeleteDialog() {
  const { state, close } = useBranchOfficeDeleteDialog()
  const dispatch = useDispatch()

  const handleDelete = useCallback(() => {
    if (state?.branchOffice) {
      dispatch(CompanyActions.deleteBranchOffice({ branchOfficeId: state.branchOffice.id }))
    }
  }, [dispatch, state?.branchOffice])

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="支店削除"
      actions={
        <FlexRow>
          <Button color="caution" onClick={handleDelete}>
            削除
          </Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <Label text={state?.branchOffice.name ?? ''} />
        <Label text="この支店を削除しますか？" />
      </FlexColumn>
    </Dialog>
  )
}
